import { EngagementErrorDialogDataModel } from './engagement-error-dialog-data.model';


export class EngagementAlreadyExecutedStrategyModel implements EngagementErrorDialogDataModel {

  engagementId: number;

  constructor(engagementId: number) {
    this.engagementId = engagementId;
  }

  getTitle() { return 'This engagement has already been executed.'; }
  getMessage() { return ''; }
  getImagePath() { return 'engagement-already-executed.png'; }
  getButtonText() { return 'Continue'; }
  getRoutePath() { return ''; }
}
